export const TOAST_VARIANTS = {
  default: 'default',
  destructive: 'destructive',
  success: 'success',
  warning: 'warning',
} as const;

export const TOAST_ANIMATION = {
  DURATION: 5000,
  SPRING_CONFIG: {
    type: 'spring',
    duration: 0.3,
  },
  EXIT_CONFIG: {
    type: 'spring',
    duration: 0.2,
  },
} as const;

export const TOAST_ICONS = {
  default: 'info',
  destructive: 'circle-alert',
  success: 'circle-check',
  warning: 'triangle-alert',
} as const;

export type ToastVariant = keyof typeof TOAST_VARIANTS; 